module.exports = __webpack_public_path__ + "5c7f315a0862ab29bf5f4ce39826440e.svg";